<template>
    <dashboard>
        <row>
            <panel size="col-5" class="filters">
                <h3 slot="title">Filters</h3>
                <div class="filter-item">
                    <h4>Student</h4>
                    <app-tag v-if="studentName" closable @close="removeStudent">{{ studentName }}</app-tag>
                    <app-button v-else @click="showPicker = true">Pick Student</app-button>
                </div>
                <student-picker v-model="showPicker" @selected-student="setStudent">
                    <template slot="title">Select Student</template>
                </student-picker>
            </panel>
            <div class="course-event-panels">
                <panel id="student-course-panel" size="col-19">
                    <h2 slot="title">
                        Student Course Report<span v-if="studentName">: {{ studentName }}</span>
                    </h2>
                    <template slot="buttons">
                        <app-button
                            size="small"
                            icon="icon-download"
                            class="no-text"
                            @click="handleDownload">
                            <span class="visuallyhidden">Download Report</span>
                        </app-button>
                    </template>

                    <el-table
                        :data="studentCourses"
                        :default-sort="{ prop: 'title', order: 'ascending'}"
                        style="width: 100%"
                        empty-text="None"
                        @current-change="navigateToClassDetail"
                        @sort-change="sortChange">
                        <el-table-column :sortable="true" prop="title" label="Title" />
                        <el-table-column prop="identifier" label="CRN" />
                        <el-table-column prop="present_count" label="Present" width="100" />
                        <el-table-column prop="absent_count" label="Absent" width="90" />
                        <el-table-column prop="excused_count" label="Excused" width="90" />
                        <el-table-column prop="total_count" label="# of Courses" width="120" />
                        <el-table-column prop="percentage" label="Percent" width="80">
                            <template slot-scope="scope">{{ scope.row.percentage }}%</template>
                        </el-table-column>
                        <el-table-column prop="last_seen" label="Last Seen" width="110">
                            <template slot-scope="scope">
                                <template v-if="scope.row.last_seen">
                                    {{ scope.row.last_seen | moment("MM/DD/YYYY") }}
                                </template>
                                <template v-else>Never Seen</template>
                            </template>
                        </el-table-column>
                    </el-table>
                </panel>
                <panel id="student-event-panel" size="col-19">
                    <h2 slot="title">
                        Student Event Report<span v-if="studentName">: {{ studentName }}</span>
                    </h2>
                    <template slot="buttons">
                        <app-button
                            size="small"
                            icon="icon-download"
                            class="no-text"
                            @click="handleDownload">
                            <span class="visuallyhidden">Download Report</span>
                        </app-button>
                    </template>

                    <el-table
                        :data="studentEvents"
                        :default-sort="{ prop: 'title', order: 'ascending'}"
                        style="width: 100%"
                        empty-text="None"
                        @current-change="navigateToEventDetail"
                        @sort-change="sortChange">
                        <el-table-column :sortable="true" prop="title" label="Title" />
                        <el-table-column prop="identifier" label="Date" />
                        <el-table-column prop="present_count" label="Present" width="110" />
                        <el-table-column prop="absent_count" label="Absent" width="100" />
                        <el-table-column prop="excused_count" label="Excused" width="100" />
                        <el-table-column prop="total_count" label="# of Events" width="120" />
                        <el-table-column prop="percentage" label="Percent" width="110">
                            <template slot-scope="scope">{{ scope.row.percentage }}%</template>
                        </el-table-column>
                    </el-table>
                </panel>
            </div>
        </row>
    </dashboard>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import table from '../../../mixins/table'
import download from '../../../mixins/download'

import StudentPicker from '../Student/StudentPicker'

export default {
    name: 'page-reports-class',
    components: {
        StudentPicker
    },
    mixins: [download, table],
    props: {
        uuid: String
    },
    data() {
        return {
            studentName: '',
            showPicker: false,
            tableParamKeys: ['uuid'],
            sortReport_dir: 'asc'
        }
    },
    computed: {
        ...mapState({
            studentCourses: ({ reportList }) => reportList.studentCourses,
            studentEvents: ({ reportList }) => reportList.studentEvents,
            authToken: ({ me }) => me.token
        })
    },
    mounted() {
        this.getStudentReport(this.getParameters())
        if (this.uuid) {
            this.getStudentDetail(this.uuid).then(({ first_name, last_name }) => {
                this.studentName = first_name + ' ' + last_name
            })
        }
    },
    methods: {
        ...mapActions(['getStudentReport', 'getStudentDetail']),
        handleDownload() {
            let parameters = this.getParameters()
            parameters.sort_by = 'title'
            parameters.sort_dir = this.sortReport_dir
            this.postParameters('/api/v2/download/report/student', parameters, this.authToken)
        },
        paramsChanged(params) {
            this.getStudentReport(params)
        },
        navigateToClassDetail({ uuid }) {
            this.$router.push({
                name: 'courses.detail',
                params: { uuid: uuid }
            })
        },
        navigateToEventDetail({ uuid }) {
            this.$router.push({ name: 'events.detail', params: { uuid: uuid } })
        },
        setStudent({ uuid, first_name, last_name }) {
            let params = { uuid: uuid }
            if (first_name && last_name) {
                this.studentName = first_name + ' ' + last_name
            }
            else {
                this.studentName = ''
            }

            this.setParameters(params)
        },
        removeStudent() {
            this.setStudent({
                id: null,
                uuid: null,
                first_name: null,
                last_name: null
            })
        },

        sortChange(sort) {
            this.sortReport_dir = sort.order == 'descending' ? 'desc' : 'asc'
        }
    }
}
</script>

<style lang="stylus">
.course-event-panels
    margin-left: 10px
    width: 100%

#student-course-panel, #student-event-panel
    padding: 0
    width: 100%

#student-course-panel
    margin-bottom: 40px
</style>
